<template>
  <div class="order">
    <figure class="order-picture">
      <img
        v-if="order.picture"
        :src="order.picture"
        :alt="order.title"
      >
      <img
        v-else
        src="@/assets/images/event-default.jpg"
        :alt="order.title"
      />
    </figure>
    <div class="order-content">
      <span class="order-date">{{ order.date.label }}</span>
      <h2 class="order-title">{{ order.title }}</h2>

      <!-- Streaming -->
      <template v-if="order.stream">
        <span class="order-label label">Streaming</span>

        <div
          v-if="expand"
          class="order-access"
        >
          <p
            v-for="access in order.access"
            :key="`${order.attractionid}-${access}`"
            class="order-access-item"
          >
            Votre code : <strong>{{ access }}</strong>
          </p>
        </div>
        <btn
          v-if="expand"
          :href="order.url"
          @click.native="onLiveStream"
        >
          Accéder au streaming
        </btn>
        <btn
          :theme="'dark'"
          @click="onDisplay"
        >
          <span v-if="!expand">{{ order.access.length > 1 ? 'Afficher mes codes d\'accès' : 'Afficher mon code d\'accès' }}</span>
          <span v-else>{{ order.access.length > 1 ? 'Masquer mes codes d\'accès' : 'Masquer mon code d\'accès' }}</span>
        </btn>
      </template>
      <!-- Event -->
      <template v-else>
        <span class="order-location">{{ order.location }}</span>
        <div
          v-if="expand"
          class="order-tickets"
        >
          <div
            v-for="ticket in order.tickets"
            :key="`${order.attractionid}-${ticket.id}`"
            class="order-ticket"
          >
            <span
              v-if="ticket.title"
              class="order-ticket-value"
            >
              <span>{{ ticket.title }}</span>
            </span>

            <div class="order-ticket-content">
              <span class="order-ticket-label">
                {{ ticket.category }}
              </span>

              <btn @click="onQR(ticket)">Afficher QR code</btn>
            </div>
          </div>
        </div>
        <btn
          :theme="'dark'"
          @click="onDisplay"
          v-on:position="position"
        >
          <span v-if="!expand">{{ order.tickets.length > 1 ? 'Afficher mes billets' : 'Afficher mon billet' }}</span>
          <span v-else>{{ order.tickets.length > 1 ? 'Masquer mes billets' : 'Masquer mon billet' }}</span>
        </btn>
      </template>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';

export default {
  components: {
    Btn
  },
  props: {
    order: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      expand: false,
      position: '',
    };
  },
  methods: {
    onDisplay() {
      this.expand = !this.expand;
    },
    onQR(ticket) {
      this.position = window.scrollY;
      this.$emit('position', this.position);
      this.$store.commit('profile/setTicket', ticket);
      console.log(ticket, 'aqui');
    },
    onLiveStream() {
      this.$ga.event('webapp', 'access_stream', this.order.title);
    }
  }
};
</script>

<style lang="scss" scoped>
.order {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: $black-light;

  &-picture {
    @include aspect-ratio(315, 163);
    width: 100%;

    img {
      @include position(absolute, 0 null null 0);
      @include size(100%);
      object-fit: cover;
    }
  }

  &-content {
    @include padding(16px 16px 24px);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;

    > .btn {
      width: calc(100% - 32px);

      &:not(.cta) {
        @include margin(24px null null);
        background-color: $black;
        border-color: $black;
      }

      &.cta {
        + .btn {
          margin-top: 17px;
        }
      }
    }
  }

  &-date {
    font-size: rem(16px);
    line-height: (19 / 16);
  }

  &-title {
    @include font('primary', 'regular');
    @include margin(8px null null);
    color: $primary;
    font-size: rem(28px);
    line-height: (33 / 28);

    strong {
      @include font('secondary', 'bold');
      display: block;
    }
  }

  &-label {
    margin-top: 6px;
  }

  &-location {
    @include margin(8px null null);
    font-size: rem(13px);
    line-height: (15 / 13);
  }

  &-access {
    margin-top: 33px;

    &-item {
      @include font('secondary', 'regular');
      color: $grey;
      font-size: rem(20px);
      line-height: (24 / 20);

      &:not(:first-child) {
        margin-top: 8px;
      }

      strong {
        color: $white;
      }
    }

    + .btn {
      margin-top: 33px;
    }
  }

  &-tickets {
    @include margin(32px null 8px);

    &:not(:first-child) {
      @include padding(8px null null);
    }
  }

  &-ticket {
    @include font('secondary', 'regular');
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    outline: none;
    font-size: rem(16px);
    line-height: (23 / 19);

    &:not(:first-child) {
      @include padding(20px null null);
    }

    &:not(:last-child) {
      @include padding(null null 24px);
    }

    @include mq($until: 'xxs') {
      font-size: rem(13px);
    }

    &-value {
      @include margin(null 16px null null);
      @include size(53px);
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background-color: $black;
      border-radius: 50%;

      @include mq($until: 'xxs') {
        @include size(43px);
      }

      span {
        @include position(absolute, 50% null null 0);
        @include padding(2px null null);
        @include size(100%, auto);
        transform: translateY(-50%);
        text-align: center;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .btn {
        margin-top: 10px;
        width: 100%;
      }
    }

    &-label {
      @include margin(null 20px null null);
      @include padding(2px null null);
      text-align: left;
    }

    + .order-ticket {
      border-top: 1px dashed $grey;
    }
  }

  // &-link {
  //   @include margin(20px null null);
  //   @include font('secondary', 'regular');
  //   @include padding(12px null 10px);
  //   @include size(100%, auto);
  //   border: 1px solid $primary;
  //   color: $primary;
  //   font-size: rem(16px);
  //   line-height: 1;
  //   text-align: center;
  // }
}
</style>
